import { Field } from 'formik';
import React from 'react';
import styles from './radio-group.module.css';
import { validateRadio } from '~/common/util/customValidation';

interface RadioFieldGroupProps {
  label: string;
  name: string;
  options: { [key: string]: string }[];
  error: string;
  errorMessage: string;
  onFocus: () => void;
  onBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
}

export const RadioFieldGroup = ({
  name,
  options,
  label,
  error,
  errorMessage,
  onFocus,
  onBlur,
}: RadioFieldGroupProps) => {
  return (
    <div>
      <fieldset className={styles.wrapper}>
        <label className={styles.label}>{label}</label>
        <div className={styles.buttons}>
          <Field
            name={name}
            validate={validateRadio}
            render={({ field }: { field: any }) => {
              return options.map((option) => {
                const fieldName = Object.keys(option)[0] as string;
                return (
                  <label className={styles.radio}>
                    <input
                      type={'radio'}
                      name={name}
                      id={fieldName}
                      {...field}
                      value={fieldName}
                      checked={field.value === fieldName}
                      onFocus={onFocus}
                      onBlur={(event: React.FocusEvent<HTMLInputElement>) => onBlur(event)}
                    />
                    <div className={styles.radioButton}>&nbsp;</div>
                    {fieldName}
                  </label>
                );
              });
            }}
          />
        </div>
        {error && <div className={styles.errorMessage}>{errorMessage}</div>}
      </fieldset>
    </div>
  );
};
